import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import InputContainer from "../../pages/citizen/TCPForms/layout/inputContainer";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../pages/citizen/TCPForms/components/Button";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

const FarDetails = ({ formData, setCurrentTab, farDetails, setFarDetails, empRole }) => {
  const { t } = useTranslation();
  const isAVP = empRole?.tenantId === "up.avp";
  const Modal = useModal();
  const properties = formData?.descriptionOfLand?.properties?.[0];
  const factorString = properties?.landUseAsPerLayout;
  const factorNum = React.useMemo(() => {
    if (factorString === "Residential (Group Housing)" || factorString === "Hotel") {
      return 0.4;
    } else if (factorString === "Office/Organization" || factorString === "Mixed land") {
      return 0.45;
    } else if (factorString === "Commercial") {
      return 0.5;
    } else {
      return 0.2;
    }
  }, [factorString]);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData?.descriptionOfLand,
      properties: [{ ...formData?.descriptionOfLand?.properties?.[0] }],
    },
  };
  const { control, handleSubmit, setValue } = useForm({ defaultValues });
  console.log(properties, "properties", formData);
  const handleInputChange = (name, value) => {
    setFarDetails({ ...farDetails, [name]: value });
  };
  useEffect(() => {
    const circleRate = Digit?.SessionStorage?.get("circleRate");
    if (circleRate) {
      setValue("circleRate", circleRate);
    }
  }, []);
  const onSubmit = (data) => {
    // data.descriptionOfLand={
    //     ...data.descriptionOfLand,
    //     descriptionOfLand: {
    //         ...data?.descriptionOfLand,
    //         properties: [{ ...data?.descriptionOfLand?.properties?.[0], }],
    //       },
    // }

    Modal("FAR Details Saved", `FAR Details Saved for <strong>${formData?.applicationNo}</strong> successfully`, "success");
    Digit?.SessionStorage?.set("circleRate", data?.circleRate);
    setCurrentTab(undefined, "2");
    console.log(data, "datafromFARFEES");
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Table bordered className="m-0" onBlur={(e) => handleInputChange(e.target.name, e.target.value)}>
        <thead className="table-header">
          <tr>
            <th style={{ minWidth: "fit-content" }}>Field Name</th>
            <th style={{ minWidth: "fit-content" }}>Input Data</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <b>{t("Required FAR")}</b>
            </td>
            <td>{properties?.percentRequiredFAR}</td>
          </tr>
          <tr>
            <td>
              <b>{t("Required FAR Area")}</b>
            </td>
            <td>{properties?.requiredAreaFAR}</td>
          </tr>

          {isAVP ? (
            <tr>
              <td>
                <b>{t("Enter Base FAR")}</b>
              </td>
              <td>
                {
                  <InputContainer
                    type="textInput"
                    name="baseFar"
                    hasLabel={false}
                    control={control}
                    validation={{
                      required: { value: true, message: "Please enter the road width." },
                    }}
                  />
                }
              </td>
            </tr>
          ) : (
            formData?.taxHeadEstimates?.[0]?.basicFar && (
              <tr>
                <td>
                  <b>{t("Basic FAR and Area (SqM)")}</b>
                </td>
                <td>{`${formData?.taxHeadEstimates?.[0]?.basicFar} and ${formData?.taxHeadEstimates?.[0]?.totalBuiltUpArea}`}</td>
              </tr>
            )
          )}
          {formData?.taxHeadEstimates?.[0]?.permissibleFAR && (
            <tr>
              <td>
                <b>{t("Permissible Purchasable FAR and Area (SqM)")}</b>
              </td>
              <td>{`${formData?.taxHeadEstimates?.[0]?.permissibleFAR} and ${formData?.taxHeadEstimates?.[0]?.permissibleFARArea}`}</td>
            </tr>
          )}

          {formData?.taxHeadEstimates?.[0]?.totalPermissibleFar && (
            <tr>
              <td>
                <b>{t("Maximum Permissible Purchasable FAR and Area (SqM)")}</b>
              </td>
              <td>{`${formData?.taxHeadEstimates?.[0]?.totalPermissibleFar} and ${formData?.taxHeadEstimates?.[0]?.totalPermissibleFARArea}`}</td>
            </tr>
          )}
          <tr>
            <td>
              <b>{t("Factor")}</b>
            </td>
            <td>{formData?.taxHeadEstimates?.[0]?.factor}</td>
          </tr>
          {!isAVP && (
            <tr>
              <td>
                <b>{t("Enter Circle Rate")}</b>
              </td>
              <td>
                {
                  <InputContainer
                    type="textInput"
                    name="circleRate"
                    hasLabel={false}
                    control={control}
                    validation={{
                      required: { value: true, message: "Please enter the road width." },
                    }}
                  />
                }
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div className="footerContainer" style={{ marginTop: "18px" }}>
        <div className="buttonWrapper">
          <ButtonWrapper variant="contained" color="success" size="medium" label={t("Save FAR Details")} type="submit" />
        </div>
      </div>
    </form>
  );
};

export default FarDetails;
